/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

const apiGet = async (url, apiOptions = {}, apiHeaders = {}, errorHandler) => {
  const defaultOptions = {
    credentials: 'include',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  const {headers} = defaultOptions;
  defaultOptions.headers = {...headers, ...apiHeaders};
  const options = {...defaultOptions, ...apiOptions};

  let error = false;

  return await fetch(url, options)
    .then(response => {
      error = !response.ok;
      return response.json();
    })
    .then(data => {
      if (error && errorHandler) errorHandler(data);
      return data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

const apiPost = async (url, body, apiHeaders = {}) => {
  let responseCode, correlationId;

  const postRequest = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  postRequest.headers = {...postRequest.headers, ...apiHeaders};

  return await fetch(url, postRequest)
    .then(response => {
      correlationId = response.headers.get('x-jpm-correlation-id');
      responseCode = response.status;
      return response.json();
    })
    .then(data => {
      return {data, status: responseCode, correlationId};
    })
    .catch((err) => Promise.reject(err));
};

export {apiGet, apiPost};
